var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"name":_vm.name,"title":"Create Referral"},on:{"closed":_vm.close}},[[_c('EncounterReferralForm')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }